<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Archive Client Invoice?</p>
      </header>
      <section class="modal-card-body">
        <b-message type="is-warning">
          <p>Are you sure you want to archive this invoice?</p>
        </b-message>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-danger"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >Archive Invoice</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api', 'context'])
  },
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/admin/client-invoices/' + this.invoice.id
      this.$http.delete(endpoint).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-success', message: 'Invoice archived!' })
        this.$router.push({ name: 'network.finance.client.invoices', params: { code: this.context.code } })
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: {
    invoice: {
      type: Object,
      required: true
    }
  }
}
</script>
